<template>
    <v-dialog
        class="picture-viewer"
        v-if="!!show.selection"
        v-model="show.viewer"
        fullscreen 
        hide-overlay 
        transition="dialog-bottom-transition"
    >
        <v-card 
            tile 
            flat
            class="picture-viewer-image py-10 d-flex flex-column"
            color="black"
        >
            <div class="d-flex flex-grow-0 custom-white-text" :class="details ? 'gray-75' : 'semi-gray'" style="position: absolute; width: 100%; z-index: 100;">
                <v-btn 
                    icon 
                    @click="details = !details"
                    class="ma-5"
                >
                    <v-icon class="details-icon custom-white-text" :class="details ? 'details-showing' : 'details-hiding'">mdi-chevron-up</v-icon>
                </v-btn>

                <div class="d-flex flex-column justify-center ma-5">
                    <h4 class="custom-white-text pa-0">{{ show.selection.title }}</h4>
                    <v-expand-transition>
                        <div v-if="details">
                            <small v-if="show.selection.desc" v-html="show.selection.desc + '<br>'" class="custom-white-text" />
                            <small v-if="show.selection.location" v-html="show.selection.location + '<br>'" class="custom-white-text" />
                            <small v-if="show.selection.dimensions" v-html="show.selection.dimensions + '<br>'" class="custom-white-text" />
                        </div>
                    </v-expand-transition>
                </div>

                <v-spacer></v-spacer>

                <v-btn 
                    icon 
                    @click="clearViewer"
                    class="ma-5"
                >
                    <v-icon class="custom-white-text">mdi-close</v-icon>
                </v-btn>
            </div>

            <v-card-text class="d-flex flex-grow-1 align-center">
                <v-img :src="show.selection.src" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'PicViewer',
    props: [
        'show'
    ],
    data() {
        return {
            details: true,
        }
    },
    methods: {
        run(method, params = null) {
            if(typeof this[method] === 'function') {
                !!params ? this[method]( params ) : this[method]()
            }
            else {
                this.$emit( 'run', method, params )
            }
        },
        clearViewer() {
            this.$emit( 'run', 'clearViewer' )
            this.details = true
        },
    },
}
</script>

<style scoped>
.picture-viewer-image > div {
    transition: all .2s;
}

.details-icon {
    transition: all .2s;
}

.details-icon.details-hiding {
    transform: rotate(180deg)
}

.picture-viewer-image {
    background-size: contain;
    background-position: center;
}
    
</style>